import styled from 'styled-components';
import color from '../../configs/color';

const Wrapper = styled.div`
  position: relative;
  .component_content_form_wrapper {
    max-width: 480px;
    border-radius: 8px;
    margin: 0 auto;
    background-color: ${color.white};
  }

  .container_form_button.ant-form-item {
    margin-bottom: 12px;
  }

  .ant-form-item-control-input-content .ant-input {
    background-color: unset;
    border: 1px solid ${color.grey5};
    padding: 12px;
  }

  .ant-input-affix-wrapper {
    border: 1px solid ${color.grey5};
    border-radius: 8px;
    padding: 12px;
  }

  #basic_password,
  #basic_confirm_password {
    border: unset;
    padding: 0;
  }
`;

export default Wrapper;
